module.exports = __webpack_public_path__ + "static/media/search-circle.5d99fc41.svg";